module.exports = __webpack_public_path__ + "bc3f17b395ea75d350fb133050e90261.svg";